export default {"src":"/_next/static/media/googlePlay.7bb413d5.svg","height":21,"width":19,"blurWidth":0,"blurHeight":0};